<template>
    <div class="add-invoice-modal" v-if="currentComponent">
        <el-dialog
            width='600px'
            :title= "translate('add_modal.title')"
            :visible.sync='show'
            :close-on-click-modal='false'
            :before-close='close'
        >
            <component
                :is="currentComponent"
                @close="close"
                @refreshStockPage="refreshStockPage"
                ref="AddInvoiceModalComponent"
            />
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'AddInvoiceModal',
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/main/components/add-invoice-modal/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        close() {
            if (this.$refs.AddInvoiceModalComponent) this.$refs.AddInvoiceModalComponent.resetData();
            this.$emit('close');
        },
        refreshStockPage() {
            this.$emit('refreshStockPage');
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}
</style>
